module.exports = __webpack_public_path__ + "img/setting-widget_sp.png";